import { getContext } from '@fiverr-private/fiverr_context';
import { SELLER_ID_QUERY_KEY, SELLER_NAME_QUERY_KEY } from '@fiverr-private/upsell';
import { ComplianceType, ComplianceTypes, QuestionsSubmitData } from '../components/ComplianceModal/types';
import { HandlePaymentRequestResponse } from '../components/ComplianceProvider/types';
import { createPaymentSession } from '../api';
import { getPageSource, redirectToPaymentsPage } from '../utils';
import { reportEventsApi } from '../biEvents';

export const usePayment = () => {
    const { organizationId, userId } = getContext();

    const handlePayment = async ({
        complianceType,
        currency,
        sellerId,
        classificationAnswers,
        discountInPercents = 0,
        requeseteeUserName,
        templateIds,
        isFree,
    }: {
        complianceType: ComplianceType;
        sellerId: number;
        currency?: string;
        classificationAnswers?: QuestionsSubmitData;
        discountInPercents?: number;
        requeseteeUserName?: string;
        templateIds?: string[];
        isFree?: boolean;
    }): Promise<HandlePaymentRequestResponse> => {
        if (!userId || !organizationId) return { isRedirecting: false };

        const url = new URL(window?.location.href);
        url.searchParams.set('complianceSentType', complianceType);
        url.searchParams.set(SELLER_ID_QUERY_KEY, String(sellerId));
        url.searchParams.set(SELLER_NAME_QUERY_KEY, requeseteeUserName ?? '');

        const redirectUrl = url.toString();

        const { paymentSessionId, subscriptionEventId } = await createPaymentSession({
            requesteeId: sellerId,
            complianceType,
            currency,
            redirectUrl,
            source: getPageSource(),
            discountInPercents: isFree ? 100 : discountInPercents,
            auditAnswers: classificationAnswers,
            templateIds,
        });

        if (paymentSessionId) {
            redirectToPaymentsPage(paymentSessionId);
            if (complianceType === ComplianceTypes.LEGAL_DOCS) {
                reportEventsApi.clickContinueToPayment({
                    pageName: getPageSource(),
                    sellerId,
                });
            }
            return { isRedirecting: true };
        }

        const shouldRefetchData = subscriptionEventId && complianceType !== ComplianceTypes.LEGAL_DOCS;

        return { isRedirecting: false, shouldRefetchData };
    };

    return {
        handlePayment,
    };
};
